import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/redux';
import { Link, Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { getIncludedInTariffText, getTariffsWithIncludedDevice } from "../../../../store/blocks/devices/selectors";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var _DeviceIncludedIn = function _DeviceIncludedIn(_ref) {
  var IncludedTariffText = _ref.IncludedTariffText,
    includedIn = _ref.includedIn;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('container'),
    "data-t-id": "components-DeviceIncludedIn"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size5-r-s"
  }, IncludedTariffText), /*#__PURE__*/React.createElement("div", {
    className: cx('included-in-tariffs')
  }, includedIn.map(function (_ref2) {
    var name = _ref2.name,
      url = _ref2.url;
    return /*#__PURE__*/React.createElement(Link, {
      href: url,
      isNoUnderline: true,
      key: name,
      size: "size5-m"
    }, "\xAB".concat(name, "\xBB"));
  })));
};
_DeviceIncludedIn.propTypes = process.env.NODE_ENV !== "production" ? {
  IncludedTariffText: PropTypes.string,
  includedIn: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    url: PropTypes.string
  })),
  price: PropTypes.shape({
    unit: PropTypes.string,
    value: PropTypes.number
  })
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    IncludedTariffText: getIncludedInTariffText(state),
    includedIn: getTariffsWithIncludedDevice(state),
    shouldRender: !!getTariffsWithIncludedDevice(state).length
  };
};
export var DeviceIncludedIn = compose(connect(mapStateToProps), withRenderFlag)(_DeviceIncludedIn);